import { render, staticRenderFns } from "./dynamicNews.vue?vue&type=template&id=a7245cb4&scoped=true&"
import script from "./dynamicNews.vue?vue&type=script&lang=js&"
export * from "./dynamicNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7245cb4",
  null
  
)

export default component.exports